/**
 * SemanticEdge - Custom edge for AI-generated connections
 *
 * Shows animated connections with labels
 */

import React from 'react';
import { BaseEdge, EdgeLabelRenderer, getBezierPath } from '@xyflow/react';

const SemanticEdge = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  label,
  data,
  selected,
  animated,
}) => {
  const [edgePath, labelX, labelY] = getBezierPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  });

  const strength = data?.strength || 0.5;
  const strokeWidth = 1 + strength * 2;
  const opacity = 0.4 + strength * 0.4;

  return (
    <>
      <BaseEdge
        id={id}
        path={edgePath}
        style={{
          stroke: selected ? '#818cf8' : '#6366f1',
          strokeWidth,
          opacity,
          strokeDasharray: animated ? '5,5' : undefined,
        }}
        className={animated ? 'animate-dash' : ''}
      />

      {/* Edge label */}
      {label && (
        <EdgeLabelRenderer>
          <div
            style={{
              position: 'absolute',
              transform: `translate(-50%, -50%) translate(${labelX}px, ${labelY}px)`,
              pointerEvents: 'all',
            }}
            className="px-2 py-0.5 bg-gray-800/90 border border-gray-700 rounded text-[10px] text-gray-300 whitespace-nowrap"
          >
            {label}
          </div>
        </EdgeLabelRenderer>
      )}
    </>
  );
};

export default SemanticEdge;
